import { Toaster } from 'sonner';

export const ToastProvider = () => {
  return <Toaster richColors position="bottom-right" visibleToasts={1} />;
};
